// Capabilities verified against the shipped guides and current implementation.
// Descriptions of how a role uses them belong in the seed, not this registry.
const USE_CASE_CAPABILITIES = {
  chat: { icon: 'message', label: 'Chat & Auto', href: '/docs/chat' },
  research: { icon: 'magnifying-glass', label: 'Research with sources', href: '/learn/research' },
  work: { icon: 'briefcase', label: 'Work', href: '/docs/work', requirement: 'Work requires Plus and uses credits.' },
  documents: { icon: 'file-lines', label: 'Documents & PDFs', href: '/docs/work-documents' },
  spreadsheets: { icon: 'table', label: 'Spreadsheets', href: '/docs/work-spreadsheets' },
  presentations: { icon: 'file-powerpoint', label: 'Presentations', href: '/docs/work-presentations' },
  code: { icon: 'code', label: 'Code & interactive tools', href: '/docs/work-files' },
  images: { icon: 'image', label: 'Image creation & editing', href: '/docs/work-images' },
  video: { icon: 'film', label: 'Video projects', href: '/docs/work-videos' },
  music: { icon: 'music', label: 'Music generation', href: '/learn/music-generation' },
  voice: { icon: 'microphone', label: 'Voice conversations', href: '/learn/voice-and-search' },
  memory: { icon: 'brain', label: 'Memory & Ideas', href: '/docs/memory', requirement: 'You control memory and learning in Settings.' },
  collections: { icon: 'folder-open', label: 'Collections', href: '/docs/collections' },
  bots: { icon: 'robot', label: 'Custom Bots', href: '/docs/agents' },
  schedule: { icon: 'calendar', label: 'Scheduled tasks', href: '/docs/tasks', requirement: 'Use /schedule or Tasks, choose timing and delivery, then press Create. A draft does not create a schedule.' },
  goals: { icon: 'bullseye', label: 'Work goals', href: '/docs/work', requirement: 'Choose Work, use /goal and explicitly start the goal. Normal credit and access controls apply.' },
  sites: { icon: 'globe', label: 'Site publishing', href: '/docs/sites', requirement: 'Preview the result and choose Publish yourself. Published sites are public.' },
  local: { icon: 'folder', label: 'Mac project folders', href: '/docs/mac-local-work', requirement: 'Local folder and command access requires the direct-download Mac edition and your approval.' },
  remote: { icon: 'laptop', label: 'Remote', href: '/docs/remote', requirement: 'Pair your phone with the direct-download Mac app; keep the Mac awake and online.' },
  plugins: { icon: 'plug', label: 'Plugins & connections', href: '/docs/plugins', requirement: 'Configure supported connections in compatible Mac Settings and approve the required access.' },
  api: { icon: 'code', label: 'Developer API', href: '/docs/api' },
  maps: { icon: 'location-dot', label: 'Maps & place guides', href: '/docs/maps' },
};

function getUseCaseFeatureUses(items) {
  return Array.isArray(items) ? items.filter(item => typeof item?.key === 'string'
    && Object.prototype.hasOwnProperty.call(USE_CASE_CAPABILITIES, item.key)
    && typeof item.description === 'string' && item.description.trim()) : [];
}

function safeUseCaseToolHref(value) {
  return typeof value === 'string' && /^\/(?:docs|learn|tools)\/[a-z0-9-]+$/.test(value) ? value : null;
}

function useCaseWorkflowGuide(outputType, mode, filename = '') {
  // HTML samples can be displayed as cards or documents, but visitors create
  // them through Work's file/preview tools rather than the slide editor.
  const key = mode === 'chat' ? 'chat' : /\.(html|js)$/.test(filename) ? 'code' : ({
    table: 'spreadsheets', chart: 'spreadsheets', code: 'code', artifact: 'code',
    gallery: 'images', presentation: 'presentations',
    document: 'documents', draft: 'documents', checklist: 'documents', timeline: 'documents',
  }[outputType] || 'work');
  return USE_CASE_CAPABILITIES[key];
}

module.exports = { USE_CASE_CAPABILITIES, getUseCaseFeatureUses, safeUseCaseToolHref, useCaseWorkflowGuide };
